import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocStatusAndJustificationRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentStatus = control.get('documentStatus')!.value;
	const documentNotes = control.get('documentNotes')!.value;

	return documentStatus ===  "90" && !documentNotes  ? { checkDocStatusAndJustificationFlag: true } : null;
};
